import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { setLocalNewletterConsent } from 'Redux/ducks/auth';

const GiveawayRequired = ({ localNewsletterConsent }) =>
  <div className="product-giveaway-newsletter-required">
    <div className="subscribe-area">
      <div className="subscribe-text">
        <FormattedMessage id="giveaway-required.subscribe" defaultMessage="Subscribe to our Email Newsletter to get this offer." />
      </div>
      <div className="checkbox-label-container">
        <input
          id="join-newsletter"
          name="join-newsletter"
          type="checkbox"
          aria-label="Join newsletter"
          checked={localNewsletterConsent}
          onChange={e => setLocalNewletterConsent(e.target.checked, false, true)}
        />
        <label htmlFor="join-newsletter" className="label-text">
          <FormattedMessage id="giveaway-required.checkbox-label" defaultMessage="Please subscribe me to Fanatical's Email Newsletter." />
        </label>
      </div>
    </div>
    <div className="subscribe-smallprint">
      <FormattedMessage
        id="giveaway-required.small-print"
        defaultMessage="You can unsubscribe via the newsletter at any time. By subscribing to our newsletter you agree to our {privacyPolicyLink}."
        values={{ privacyPolicyLink: <a href={'https://www.fandom.com/privacy-policy'} target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="giveaway-required.small-print.privacy-policy" defaultMessage="Privacy Policy" />
        </a>,
        }}
      />
    </div>
  </div>;

GiveawayRequired.propTypes = {
  localNewsletterConsent: PropTypes.number,
};

GiveawayRequired.defaultProps = {
  localNewsletterConsent: 0,
};

const mapStateToProps = ({
  auth: { localNewsletterConsent },
}) => ({ localNewsletterConsent });

export default connect(mapStateToProps)(GiveawayRequired);
